export const environment = {
    staging: true,
    hmr:false,
    production: false
  };
  